import { Eye, BadgeDollarSign, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const featureIcons = [Eye, BadgeDollarSign, Target];
const featureKeys = ['visibility', 'free', 'long_term'] as const;

const ValuePropositionSection = () => {
  const { t } = useTranslation();

  return (
    <section id="advantages" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-emerald-600 uppercase mb-4">
            {t('simonsMarketing.value_proposition.badge')}
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            <span className="font-extrabold">{t('simonsMarketing.value_proposition.title_prefix')}</span>
            {t('simonsMarketing.value_proposition.title_suffix')}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {featureKeys.map((key, index) => {
            const Icon = featureIcons[index];
            return (
              <div
                key={key}
                className="group relative bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl hover:shadow-gray-200/50 transition-all duration-500 border border-transparent hover:border-gray-100"
              >
                <div className="absolute top-0 left-8 w-12 h-1 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-full transform -translate-y-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="w-14 h-14 rounded-xl bg-emerald-100 flex items-center justify-center mb-6 group-hover:bg-emerald-500 transition-colors duration-500">
                  <Icon className="w-7 h-7 text-emerald-600 group-hover:text-white transition-colors duration-500" />
                </div>

                <div className="text-xs font-bold text-gray-300 mb-3">
                  0{index + 1}
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {t(`simonsMarketing.value_proposition.features.${key}.title`)}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {t(`simonsMarketing.value_proposition.features.${key}.description`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
